import React, {RefObject} from "react";
import {Tabs} from "antd";
import "./JobSection.scss";
import {getTranslate, TranslateFunction} from "react-localize-redux";
import {connect} from "react-redux";
import Nullable from "@data-force/app/interfaces/nullable";
import JobMetadata from "./JobMetadata/JobMetadata";
import JobInfo from "./JobInfo/JobInfo";
import FileCount from "./FileCount/FileCount";
import StoreState from "../../interfaces/store/storeState";
import JobStatusStats from "./JobStatusStats/JobStatusStats";
import TaskList from "./TaskLIst/TaskList";

interface StateProps {
    translate: TranslateFunction
    batchId: Nullable<string>
}

interface OwnProps {
    headerReference: RefObject<HTMLHeadingElement>
}

type Props = StateProps & OwnProps;

const translationPath: string = "components.JobSection.JobSection";

const JobSection: React.FC<Props> = (props: Props): React.ReactElement => {
    const {translate, headerReference, batchId}: Props = props;

    return (
        <div className="df-job-section">
            <div className="df-job-info-section">
                <JobInfo/>
            </div>
            <div className="df-job-section-content">
                <Tabs type="card">
                    <Tabs.TabPane
                        tab={translate(`${translationPath}.details.text`) as string}
                        key="1"
                    >
                        <FileCount/>
                        {!!batchId && <JobMetadata headerReference={headerReference}/>}
                    </Tabs.TabPane>
                    <Tabs.TabPane
                        tab={translate(`${translationPath}.tasks.text`) as string}
                        key="2"
                    >
                        <JobStatusStats/>
                        <TaskList/>
                    </Tabs.TabPane>
                </Tabs>
            </div>
        </div>
    );
};

function mapStateToProps({
    localize,
    job: {jobDetails},
}: StoreState): StateProps {
    return {
        translate: getTranslate(localize),
        batchId: jobDetails?.batchId,
    };
}

export default connect(mapStateToProps)(JobSection);
